// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"274":"23a48993","757":"d79475af","918":"e5e34cd1","962":"975b5199"}[chunkId] + ".js";
};